
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { AdminLoadingStateProps } from './types';

const AdminLoadingState = ({}: AdminLoadingStateProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array(6).fill(0).map((_, index) => (
        <Card key={index}>
          <CardContent className="p-6">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="w-24 h-24 rounded-full bg-gray-200 animate-pulse" />
              <div className="w-3/4 h-4 bg-gray-200 rounded animate-pulse" />
              <div className="w-1/2 h-3 bg-gray-200 rounded animate-pulse" />
              <div className="w-full h-12 bg-gray-200 rounded animate-pulse mt-4" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AdminLoadingState;
